import { COLOR_GREEN, COLOR_GREY_3 } from "shared/theme/colors";
import { BulletinStatus } from "./types";

export const BULLETIN_STATUS_LABELS: Record<BulletinStatus, string> = {
  [BulletinStatus.Active]: "Published",
  [BulletinStatus.Draft]: "Inactive",
};

export const BULLETIN_STATUS_COLORS: Record<BulletinStatus, string> = {
  [BulletinStatus.Active]: COLOR_GREEN,
  [BulletinStatus.Draft]: COLOR_GREY_3,
};
